export const KEYTYPE = 'RSA'
export const KEY_WRAPPING_ALG = 'RSA-OAEP-256'
export const CONTENT_ENCRYPTION_ALG = 'A256GCM'
export const RSA_HASH = 'SHA-256'
export const RSA_ALGORITHM = 'RSA-OAEP'
export const CIPHER_ALGORITHM = 'aes256'
export const AES_KEY_LENGTH = 256
// export const AES_KEY_BYTES = 32

// export const AES_ALGORITHM = 'AES-GCM'
// export const IV_LENGTH = 12
